import React, { useState } from 'react';
import { connect } from 'react-redux';

import RecoverPasswordView from 'views/RecoverPassword';
import UserService from 'api/User';
import SettingsActions from 'store/reducers/Settings';
import { useSubmit } from 'hooks';

const RecoverPassword = ( { match, toggleLoading } ) => {
  const [dataSubmitted, setDataSubmitted] = useState( false );

  const submitForm = useSubmit( {
    promise: ( dataToSend ) => UserService.resetPassword( match.params.token, dataToSend ),
    toggleLoading,
    format: ( dataToFormat ) => ( { ...dataToFormat, passwordConfirmation: undefined } ),
    callback: () => setDataSubmitted( true ),
  } );

  return (
    <RecoverPasswordView
      dataSubmitted={dataSubmitted}
      onSubmit={submitForm}
    />
  );
};

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( RecoverPassword );
